import styled from 'styled-components';

export const Bar = styled.div`
  background: ${props => (props.isTransparent ? 'transparent' : '#fff')};
  flex-shrink: 0;
  flex-grow: 1;
  border-bottom: ${({ theme }) =>
    theme.legacy.colors.brand && `4px solid ${theme.legacy.colors.brand}`};
`;

export const Wrapper = styled.div`
  width: 100%;
  padding: 0 30px 0 20px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  height: 75px;

  @media (max-width: 1545px) {
    max-width: initial;
  }
`;

export const Logo = styled.div`
  #AdviserTopNavBar && {
    ${({ whiteLabelLogoUrl, whiteLabelDashboardLogoCssStyle }) => `
    ${whiteLabelLogoUrl ? `background-image: url(${whiteLabelLogoUrl});` : ''}
    ${whiteLabelDashboardLogoCssStyle ||
      `
      background-color: '#242424';
      margin: '0';
      width: '250px';
      `}
    `}
  }
`;
